import HcrDetailsBox from "components/common/HcrDetailsBox";
import React, { useEffect, useState } from "react";
import emailIcon from "assets/icons/email.svg";
import downloadIcon from "assets/icons/download.svg";
import tickIcon from "assets/icons/disclaimer-tick.svg";
import circle from "assets/icons/circle.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "utils/hooks";
import { currentClaimFormDataThunk, downloadClaimForm } from "store/thunk/hcr.thunk";
import { toast } from "react-toastify";
import SentEmailModal from "./components/modals/SentEmailModal";

const DownloadForm = () => {
  const hcrId: any = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const hcrDetails = useAppSelector((state) => state.rootReducer.hcrSlice.currentClaimForm);

  useEffect(() => {
    dispatch(currentClaimFormDataThunk(hcrId.id));
  }, [hcrId]);

  const downloadClaimFormHandler = async () => {
    if (!hcrDetails?.claimFormUrl) toast.error("Pdf Not Found");
    setLoading(true);
    const response = await dispatch(downloadClaimForm(hcrId?.id));

    if (response.meta.requestStatus === "fulfilled") {
      const blob = response.payload;

      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.href = url;
      a.download = "claim-form.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      toast.error("Failed to download the claim form");
    }
    setLoading(false);
  };

  const Loader = <div className="w-4 md:w-5 h-4 md:h-5 border-[2px] border-t-[#dea15c]  rounded-full animate-spin" />;
  return (
    <>
      <div className="bg-[#F0F4FD] my-4 flex md:hidden gap-4 p-5 mt-7">
        <button onClick={downloadClaimFormHandler} className={` bg-white font-bold flex gap-3 items-center px-3 py-3 border-[1px] border-borderGray rounded-lg shadow-md ${loading && "opacity-50 pointer-events-none"}`}>
          {loading ? Loader : <img src={downloadIcon} alt="download-icon" />}
          <p className="text-xs">{loading ? "Downloading" : "Download Claim Form"}</p>
        </button>
        <button onClick={() => setShowEmailModal(true)} className=" bg-white flex font-bold gap-3 px-3 items-center py-3 border-[1px] border-borderGray rounded-lg shadow-md">
          <img src={emailIcon} alt="download-icon" />
          <p className="text-xs">Get It On Email</p>
        </button>
      </div>
      <HcrDetailsBox hideSave={true} hideProgress={true} hideNext={true} progress={100} title="Download Claim Form" parentClassName="-mt-0 mt-0">
        <div className="bg-[#F0F4FD] my-4 hidden md:flex gap-4 p-8">
          <button onClick={downloadClaimFormHandler} className={` bg-white font-bold flex gap-3 px-5 py-4 border-[1px] border-borderGray rounded-lg shadow-md ${loading && "opacity-50 pointer-events-none"}`}>
            {loading ? Loader : <img src={downloadIcon} alt="download-icon" />}
            <p>{loading ? "Downloading" : "Download Claim Form"}</p>
          </button>
          <button onClick={() => setShowEmailModal(true)} className=" bg-white flex font-bold gap-3 px-5 py-4 border-[1px] border-borderGray rounded-lg shadow-md">
            <img src={emailIcon} alt="download-icon" />
            <p>Get It On Email</p>
          </button>
        </div>
        <div className="m-5 bg-[#F0F4FD] border-[1px] border-borderGray rounded-lg overflow-hidden">
          <header className="p-5 font-bold">Points to Remember</header>
          <div className="bg-white rounded-t-3xl shadow-all p-5 space-y-4 pb-10 text-sm font-medium">
            <div className="flex gap-3 items-start">
              <img src={tickIcon} alt="tick-icon" className="mt-[3px]" />
              <p>Please ensure all the documents are submitted in original for smooth processing of claim.</p>
            </div>
            <div className="flex gap-3 items-start">
              <img src={tickIcon} alt="tick-icon" className="mt-[3px]" />
              <div>
                <p>Claim documents needs to be send on below address:</p>
                <p>Signed Claim form along with the required documents to be sent via courier to the nearest TPA office or branch office of {hcrDetails?.policyId?.insuranceCompanyId?.name}</p>
              </div>
            </div>
            <div className="flex gap-3 items-start">
              <img src={tickIcon} alt="tick-icon" className="mt-[3px]" />
              <p>
                Claim payments are made only through Online Bank Transfers. Please submit the Bank
                <br /> Account details along with a cancelled cheque
              </p>
            </div>
            <div className="flex gap-3 items-start">
              <img src={tickIcon} alt="tick-icon" className="mt-[3px]" />
              <p>In Case of Medico legal or Reported to Police, it is suggested that you attach the MLC/FIR copy for smooth processing of your claim</p>
            </div>

            <div className="flex gap-3 items-start">
              <img src={tickIcon} alt="tick-icon" className="mt-[3px]" />
              <div>
                <p>Please ensure the signatures on the claim form as below:</p>
                <p className="flex gap-2">
                  <img src={circle} alt="circle" />
                  Part A – Section H: Insured Person
                </p>
                <p className="flex gap-2">
                  <img src={circle} alt="circle" />
                  Part B – Section F: Hospital{" "}
                </p>
                <p className="flex gap-2">
                  <img src={circle} alt="circle" />
                  Consent Letter (at the end of Claim Form): Insured Person{" "}
                </p>{" "}
              </div>
            </div>
          </div>
          <div className={`fixed flex md:relative bottom-0 left-0 z-10 bg-white  w-full rounded-b-lg py-3   border-t-[1px]  shadow-top overflow-hidden border-borderGray  flex-col`}>
            <div className="flex justify-center items-center gap-5 h-16 md:h-20 bg-white">
              <button onClick={() => navigate("/hcr/all-claim-form")} className={`bg-polyfix-gradient h-12 rounded-lg min-w-44 md:min-w-80 font-bold flex items-center justify-center gap-3 `}>
                <p>Go To Home</p>
              </button>
            </div>
          </div>
        </div>
        <SentEmailModal showModal={showEmailModal} hcrDetails={hcrDetails} onClose={() => setShowEmailModal(!showEmailModal)} />
      </HcrDetailsBox>
    </>
  );
};

export default DownloadForm;
